import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import {
  InvoicesResultEntity,
  InvoiceStatus,
  InvoiceListStatus,
  InvoiceReviewStatus,
} from "../../entities/InvoiceEntity";

/**
 * Get All Invoices Use Case
 * Retrieves all invoices with optional filtering and pagination
 */
export class GetAllInvoicesUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(params?: {
    limit?: number;
    offset?: number;
    status?: InvoiceStatus | InvoiceListStatus;
    reviewed?: InvoiceReviewStatus;
    search?: string;
    date_from?: string;
    date_to?: string;
    created_after?: string;
    created_before?: string;
    sort_by?:
      | "created_at"
      | "updated_at"
      | "filename"
      | "status"
      | "original_filename";
    sort_order?: "asc" | "desc";
  }): Promise<InvoicesResultEntity> {
    // Validate limit if provided
    if (params?.limit !== undefined && (params.limit < 1 || params.limit > 100)) {
      throw new Error("Limit must be between 1 and 100");
    }

    return await this.repository.fetchInvoices(params);
  }
}

